var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42568_1900",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 28.5C53 40.9264 42.9264 51 30.5 51C18.0736 51 8 40.9264 8 28.5C8 16.0736 18.0736 6 30.5 6C42.9264 6 53 16.0736 53 28.5Z",
    fill: "#F2F2F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42568_1900)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42568_1900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.291 28.5001C51.291 39.9827 41.9825 49.2913 30.4999 49.2913C19.0173 49.2913 9.70874 39.9827 9.70874 28.5001C9.70874 17.0175 19.0173 7.70898 30.4999 7.70898C41.9825 7.70898 51.291 17.0175 51.291 28.5001Z",
    fill: "#D7E3F1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.29102H54.7089V50.9999H8V4.29102Z",
    fill: "#D7E3F1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7273 26.818C37.6891 26.818 39.2609 25.2343 39.2609 23.2725C39.2609 21.3107 37.6891 19.7271 35.7273 19.7271C33.7655 19.7271 32.1818 21.3107 32.1818 23.2725C32.1818 25.2343 33.7655 26.818 35.7273 26.818ZM26.2727 26.818C28.2345 26.818 29.8064 25.2343 29.8064 23.2725C29.8064 21.3107 28.2345 19.7271 26.2727 19.7271C24.3109 19.7271 22.7273 21.3107 22.7273 23.2725C22.7273 25.2343 24.3109 26.818 26.2727 26.818ZM26.2727 29.1816C23.5191 29.1816 18 30.5643 18 33.318V35.0907C18 35.7407 18.5318 36.2725 19.1818 36.2725H33.3636C34.0136 36.2725 34.5455 35.7407 34.5455 35.0907V33.318C34.5455 30.5643 29.0264 29.1816 26.2727 29.1816ZM35.7273 29.1816C35.3845 29.1816 34.9945 29.2052 34.5809 29.2407C34.6045 29.2525 34.6164 29.2761 34.6282 29.288C35.9755 30.2689 36.9091 31.5807 36.9091 33.318V35.0907C36.9091 35.5043 36.8264 35.9061 36.6964 36.2725H42.8182C43.4682 36.2725 44 35.7407 44 35.0907V33.318C44 30.5643 38.4809 29.1816 35.7273 29.1816Z",
    fill: "#828282"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42568_1900",
    x: -2.29126,
    y: -2.29102,
    width: 65.5823,
    height: 65.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42568_1900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42568_1900",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChatIcon);
export default __webpack_public_path__ + "static/media/GroupChatIcon.e6b53c0787663c775b7a9a06056f6127.svg";
export { ForwardRef as ReactComponent };